import { Api } from '../api/Api.js'

export function apiGetSiteUsers(uuid = null, params) {
  return Api('get', `/users/get_site_users${uuid && '?uuid='+uuid}` , { params });
}

export function apiGetCodes(uuid = null, params) {
  return Api('get', `/codes/get_codes${uuid && '?uuid='+uuid}` , { params });
}


